export function homeSchema() {
  const jsonLinkedData = {
    '@context': 'https://schema.org/',
    '@type': 'WebSite',
    name: 'TV3 Play',
    url: location.origin.toString(),
    potentialAction: {
      '@type': 'SearchAction',
      target: location.origin.toString() + '/search?query={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
  document.getElementById('scriptJSON').innerText = JSON.stringify(jsonLinkedData);
}
